import AdjusterIcon from './icons/AdjusterIcon';
import BidControlIcon from './icons/BidControlIcon';
import ControllerIcon from './icons/ControllerIcon';
import DispatcherIcon from './icons/DispatcherIcon';
import MasterIcon from './icons/MasterIcon';
import WorkerIcon from './icons/WorkerIcon';
import ScheduleIcon from './icons/ScheduleIcon';
import { SvgIconProps } from '@mui/material/SvgIcon';
import WarehousesIcon from './icons/WarehousesIcon';
import DashboardIcon from './icons/DashboardIcon';

export type IServiceData = {
    title: string,          // Заголовок
    description?: string,   // Описание
    img: SvgIconProps,      // Картинка
    link: string,           // Ссылка на страницу
    dataSource?: string,    // Источник данных (нужен для чекера/проверки, есть ли данные)
    roles: string[],
}

// Данные карточек для меню 'Все сервисы'
export const ServiceDataList: IServiceData[] = [
    {
        title: 'Рабочий',
        description: 'Регистрация выработки и работа с простоями оборудования',
        img: <WorkerIcon />,
        roles: ['W'],
        link: '/worker/#/home',
    },
    {
        title: 'Наладчик',
        description: 'Создание заявок на СТО и загрузка программ для станков с ЧПУ',
        img: <AdjusterIcon />,
        roles: ['Adj'],
        link: '/adjuster/#/home',
    },
    {
        title: 'Мастер',
        description: 'Подтверждение выработки',
        img: <MasterIcon />,
        roles: ['M'],
        link: '/master/#/home',
    },
    {
        title: 'Диспетчер',
        description: 'Регистрация выработки, работа с MES заказами',
        img: <DispatcherIcon />,
        roles: ['D'],
        link: '/mes/',
    },
    {
        title: 'Контролёр',
        description: 'Отправка деталей на контроль',
        img: <ControllerIcon />,
        roles: ['Qc'],
        link: '/quality-new/#/home?mode=inWorkAvailiable',
    },
    // {
    //     title: 'Заявки на контроль',
    //     description: 'Работа с заявками на контроль качества',
    //     img: <BidControlIcon />,
    //     roles: ['Qc'],
    //     link: '/quality-backoffice/#/home',
    // },
    // {
    //     title: 'Заявки на СТО',
    //     description: 'Работа с заявками на СТО',
    //     img: <BidServiceStationIcon />,
    //     roles: ['Tkp'],
    //     link: '/toolkeeper/#/home?searchMode=id&statusByRequest=active',
    // },
    {
        title: 'Планирование',
        description: 'Управление планами работ, логистики и поставок материалов',
        img: <ScheduleIcon />,
        roles: [],
        link: '/aps/',
    },
    {
        // Заявки
        title: 'Заявки',
        description: 'Работа с заявками',
        img: <BidControlIcon />,
        roles: ['D', 'A'],
        link: '/documents/qc/',
    },
    {
        // Административная панель
        title: 'Администрирование',
        description: 'Административная панель',
        img: <DashboardIcon />,
        roles: ['A'],
        link: '/admin/',
    },
    {
        // Склад
        title: 'Склад',
        description: 'Управление местами хранения и материалами на складе',
        img: <WarehousesIcon />,
        roles: ['D', 'A'],
        link: '/wms/',
    },
]; 